// extracted by mini-css-extract-plugin
module.exports = {"root":"UrlResolverComponent_root__dCTFW","link":"UrlResolverComponent_link__dG_6Q"};